import {Api_comDwjbxxcx, Api_comDwzhlbcx} from '@/static/js/api/com/cominfo'
import StoreSaveData from '@/static/js/storeSaveData'

export default {
    state: {
        info: {
            dwzh: '',
            dwjcrs: '',
            dwfcrs: '',
            dwzhye: '',
            dwjcbl: '',
            dwkhrq: '',
            jzny: '',
            dwzhzt: '',
            jgbm: '',
            jgmc: '',
            dwmc: '',
            dwjm: '',
            dwdz: '',
            zjjgdm: '',
            dwslrq: '',
            dwyb: '',
            dwfxr: '',
            dwfrdbxm: '',
            dwfrdbzjhm: '',
            jbrxm: '',
            jbrzjhm: '',
            jbrgddhhm: '',
            jbrsjhm: '',
            dwlsgx: '',
            dwxz: '',
            dwjjlx: '',
            dwsshy: '',
            jglx: '',
            zjly: '',
            sbzh: ''
        },
        loading: true
    },
    mutations: {
        cominfoAdd(state, obj) {
            state.info = obj;
        },
        comBarLoading(state, b) {
            state.loading = b;
        }
    },
    actions: {
        updateComInfo({commit, state}) {
            console.log(state);
            const dwzh = StoreSaveData('loginInfo').unitAccount;
            // 获取单位基本信息
            commit('comBarLoading', true);
            Api_comDwjbxxcx(dwzh).then().then(res => {
                commit('comBarLoading', false);
                if (res.code === '0000000') {
                    let data = JSON.parse(res.body);
                    // 更新vuex
                    commit('cominfoAdd', data.result[0]);
                    // 保存在本地储存
                    sessionStorage.setItem('cominfo', JSON.stringify(data.result[0]));
                } else {
                    this.$Notice.error({
                        title: res.message
                    });
                }
            }).catch(err => {
                commit('comBarLoading', false);
                console.error(err);
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/cominfo.js